export default __webpack_public_path__ + "static/media/fire.b81b69f3.svg";